
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormValuesEdit } from "../../types";

interface TemplateSelectorProps {
  form: UseFormReturn<FormValuesEdit>;
  templates: { id: number; name: string }[] | undefined;
}

export function TemplateSelector({ form, templates }: TemplateSelectorProps) {
  return (
    <FormField
      control={form.control}
      name="template_v2_id"
      render={({ field }) => (
        <FormItem className="w-full">
          <FormLabel>Plantilla de Reporte</FormLabel>
          <Select value={field.value?.toString()} onValueChange={(value) => field.onChange(parseInt(value))}>
            <SelectTrigger className="w-full min-w-0">
              <SelectValue placeholder="Seleccionar plantilla" className="truncate" />
            </SelectTrigger>
            <SelectContent>
              {templates?.map((template) => (
                <SelectItem key={template.id} value={template.id.toString()}>
                  {template.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
